import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TaxViewColumnViewModelStates } from '../states';
import { columnViewModelFeatureKey3 } from '../reducers/root';
export const ViewModelSelector = createFeatureSelector<TaxViewColumnViewModelStates>(columnViewModelFeatureKey3);
export const selectGenericDocTaxListing_State = createSelector(
  ViewModelSelector, 
 (state: TaxViewColumnViewModelStates) => state.column1ViewModel.genericDocTaxListingState
);